import { Route, Switch, Redirect } from "react-router-dom";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";

// layouts
import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";
import MasterData from "layouts/MasterData.js";
import Config from "layouts/Config.js";
import Setting from "layouts/Setting.js";
import Transaction from "layouts/Transaction.js";
import Report from "layouts/Report";

// views without layouts
// import Landing from "views/Landing.js";
// import Profile from "views/Profile.js";
import Index from "views/Index.js";

// import {  useSelector } from "react-redux";
// import { useHistory } from "react-router";

// API
import { authCekLogin } from "views/auth/login/api/loginAPI";
import { useDispatch } from "react-redux";
import { setUserLogin } from "app/GlobalSlice";
import Dashboard from "layouts/Dashboard";
import { useSelector } from "react-redux";
// import AppLogout from "hooks/AppLogout";

export default function App() {
  const history = useHistory();
  const dispatch = useDispatch();

  // const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [resultLogin, setResultLogin] = useState(null);
  const [errorsLogin, setErrorsLogin] = useState(null);

  const userLogin = useSelector((state) => state.global.userLogin);

  // const userLogin = useSelector(state => state.global.userLogin);
  // Cek Login
  useEffect(() => {
    authCekLogin()
      .then((response) => setResultLogin(response))
      .catch((err) => setErrorsLogin(err));
  }, []);

  // Check if Request Failed
  useEffect(() => {
    if (errorsLogin !== null) {
      console.error(errorsLogin.message);
    }
  }, [errorsLogin]);

  // Check if Request Success
  useEffect(() => {
    if (resultLogin !== null) {
      // console.log(resultLogin.data);
      if (resultLogin.data.success === true) {
        // console.log(resultLogin.data.data);
        if (resultLogin.data.data.id_user !== null) {
          dispatch(
            setUserLogin({
              id_user: resultLogin.data.data.id_user,
              role: resultLogin.data.data.role,
              email: resultLogin.data.data.email,
              nama_user: resultLogin.data.data.nama_user,
              image_profile: resultLogin.data.data.image_profile,
            })
          );
          // setIsLoggedIn(true);
        }
      } else {
        let numericArray = [];
        for (let err in resultLogin.data.errors) {
          numericArray.push(resultLogin.data.errors[err]);
        }
        numericArray.forEach((err) => {
          console.log(err);
        });
        // setIsLoggedIn(false);
        history.push("/");
      }
    }
  }, [resultLogin, history, dispatch]);

  if (userLogin.role === null) {
    <Switch>
      <Route path="/auth" component={Auth} />
      <Route path="/" exact component={Index} />
      <Redirect from="*" to="/" />
    </Switch>;
  }

  // If User is not Admin
  return (
    // <Switch>
    //   <Route path="/admin" component={Admin} />
    //   <Route path="/auth" component={Auth} />
    //   <Route path="/transaction" component={Transaction} />
    //   <Route path="/" exact component={Index} />
    //   <Redirect from="*" to="/" />
    // </Switch>
    <Switch>
      {/* <AppLogout> */}
      <Route path="/admin" component={Admin} />
      <Route path="/setting" component={Setting} />
      <Route path="/masterData" component={MasterData} />
      <Route path="/config" component={Config} />
      <Route path="/transaction" component={Transaction} />
      <Route path="/report" component={Report} />
      <Route path="/" exact component={Index} />
      <Route path="/dashboard" exact component={Dashboard} />
      <Route path="/auth" component={Auth} />
      <Redirect from="*" to="/dashboard" />
      {/* </AppLogout> */}
    </Switch>
  );
}
